<template>
  <v-container>
   <v-row>
      <v-col
        xs="12"
      >
        <v-card>          
          <!-- <v-btn @click="googleIntegrate" fab fixed bottom right dark color="indigo">
            <v-icon dark>add</v-icon>
          </v-btn> -->
          <v-card-title class="headline">Integrações - Google</v-card-title>
          <v-card-text>
          <List/>      
          </v-card-text>
          <v-card-text>
            <button bottom @click="googleIntegrate" id="customBtn" class="customGPlusSignIn">
              <span class="icon"></span>
              <span class="buttonText">Sign in with Google</span>
            </button>
          <!-- <v-btn @click="googleIntegrate" bottom  color="#FFFFF" style="height:100%">
            <img src="../../../assets/vector/logo_google.svg"> <span style="color:white;">Google</span> 
          </v-btn> -->
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>


  import List from './List.vue';
  export default {
    components: {
      List
    },
    name: 'index',
    methods: {
      googleIntegrate() {
        this.$gAuth
        .getAuthCode()
        .then(authCode => {
          const user = localStorage.getItem('user');
          let data = null;
          if (user) {
            data = JSON.parse(user);
            data.googleAuthCode = authCode;                      
            localStorage.setItem('user', JSON.stringify(data));
          }
          console.log(data);
          this.$store.commit('setUser', {data});
          this.$store.dispatch('createGoogleOauth2', {data});
        })
        .catch(error => {
          console.log('falha ao autenticar com o google', error);
        });
      }
    },
    data () {
      return {
      }
    }
  }
</script>

<style lang="css" scoped>

  #customBtn {
      display: inline-block;
      background: white;
      color: #444;
      width: 190px;
      border-radius: 5px;
      border: thin solid #888;
      box-shadow: 1px 1px 1px grey;
      white-space: nowrap;
    }
    #customBtn:hover {
      cursor: pointer;
    }
    span.label {
      font-family: serif;
      font-weight: normal;
    }
    span.icon {
      background: url('../../../assets/vector/g-normal.png') transparent 5px 50% no-repeat;
      display: inline-block;
      vertical-align: middle;
      width: 42px;
      height: 42px;
    }
    span.buttonText {
      display: inline-block;
      font-size: 14px;
      font-weight: bold;
    }
</style>